<template>
    <zen-one :showuserinfo="false" title="Sistem Hasil Bersepadu Kedah (iHasil)" :crumbs="crumbs">
      
         <z-page title="Penyediaan Penyata Pemungut Kaunter">
          <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="submitPemugut">
            <div class="message-box">
              <w-transition-fade>
                <w-alert
                  class="my0 text-light"
                  v-if="form.submitted"
                  success
                  no-border>
                  The form is valid, ready to send it!
                </w-alert>

                <w-alert
                  class="my0 text-light"
                  v-else-if="form.valid === false"
                  error
                  no-border>
                  Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
                </w-alert>
              </w-transition-fade>
            </div>

                 <!-- <w-flex justify-space-between class="mb4">
                    <div class="xs4">
                          <h5 class="fw-semibold m0">
                              Tarikh :
                          </h5>
                          <div class="fw-normal my1 fs-1">{{date('DD-MM-YYYY')}} </div>
                    </div>
                 </w-flex> -->
                 <w-flex justify-space-between class="mb4"> 
                    <div class="xs4"> 
                         <!-- <z-lookup
                            label="Bank *" 
                            name="bank"
                            :url="
                                service_utiliti +
                                'lookup/tambah_bank'
                            "
                            :sort="false"
                            :cache="false"
                            v-model="form.bank"
                            @pilih="getBankakaun(form.bank)"
                            :validators="[
                                validators.required,
                            ]"
                        /> -->

                         <w-select 
                            :items="banks" 
                            label="Bank *" 
                            v-model="form.bank"
                            :sort="false"
                            :cache="false"
                             @input="getBankakaun()"
                             :validators="[
                                validators.required,
                            ]"
                           
                            />
                    </div>
                </w-flex>
                <w-flex justify-space-between class="mb4"> 
                    <div class="xs4"> 
                         <w-select 
                            :items="bank_akaun" 
                            label="No. Akaun"  
                            v-model="form.bank"
                             @input="getBankakaunketerangan()"
                            />
                    </div>
                </w-flex> 
                <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="Keterangan" 
                          name="bank_akaun_keterangan" 
                          v-model="form.bank_akaun_keterangan" 
                           readonly/>
                      </div>
                </w-flex>

                <!--  <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="No. Akaun *"  
                          name="no_slip_bank" 
                          v-model="form.no_akaun"
                          :validators="[validators.required,]" 
                          />
                      </div>
                </w-flex>  -->
                <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="Tarikh Slip Bank" 
                          name="tarikh_slip_bank" 
                          v-model="form.tarikh_slip_bank" 
                           type="date"/>
                      </div>
                </w-flex>
                 <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="No. Slip Bank *"  
                          name="no_slip_bank" 
                          v-model="form.no_slip_bank" 
                            maxlength="20"
                        />
                        <small style="color: red; font-size: 8pt;">
                            Max 20 aksara
                        </small>
                      </div>
                </w-flex> 
                <br>

            <w-flex justify-center align-center class="mt5">
              <div class="w-card__content content-hardcode">  
               <w-flex justify-space-between class="mb4">
                    <div class="xs4"> 
                        <z-input 
                          label="Tarikh bayar"  
                          name="no_slip_bank" 
                          v-model="form.tarikh_bayar"
                          type="date"
                          />

                    </div>
                    <div class="xs1" style="margin-top: 10px"> 
                        <w-button  :loading="form.submitted " @click="Resit()">
                            <w-icon dark tile class="mr2">fal fa-search</w-icon> Cari
                        </w-button>
                    </div>
                    <div class="xs4"> 
                    </div>
                </w-flex> 

                <w-flex justify-space-between class="mb4"> 
                     <div class="xs4"> 
                        Penyata Pemungut Asal Pemulangan Cek
                    </div>
                    <div class="xs4"> 
                         <w-switch class="mr6" v-model="form.cek"></w-switch>
                    </div>


                    <div class="xs4"> 
                    </div>
                </w-flex>
                <template v-if="form.cek == 1">
                    <w-flex justify-space-between class="mb4">
                        <div class="xs4" style="margin-top: 10px"> 
                            
                            {{form.no_penyata_pemungut}}
                        </div>
                        <div class="xs4" style="margin-top: 10px"> 
                             <w-button  :loading="form.submitted " @click="Cek()">
                                <w-icon dark tile class="mr2">fal fa-search</w-icon> Penyata Pemungut Pemulangan Cek
                            </w-button>
                        </div>
                        <div class="xs4"> 
                        </div>
                    </w-flex>  
                </template>                     
                <table class="table-dashboard" width="100%">
                    <thead>
                        <tr>
                            <!-- <td>Tarikh</td> -->
                            <td>Kaunter</td>
                            <td>Cara Bayar</td>
                            <td>Amaun (RM)</td>
                            <td>  <w-checkbox
                                        v-model="pilih"
                                        @click="cekPilih"
                                    ></w-checkbox></td>
                        </tr>
                    </thead>
                    <!-- <tbody> -->
                    <tbody v-if="form.resit.length > 0">
                        <tr v-for="(dt, index) in form.resit">
                                <td>{{ dt.kod }}</td>
                                <td>{{dt.keterangan}} 
                                    <template v-if="dt.lkp_cara_bayaran_id == 32">( {{dt.no_dokumen}} )</template>
                                 </td>

                                <td align="right">
                                    {{ $zutil.currency(dt.total) }}
                                </td>
                                <td>
                                     <w-checkbox
                                        v-model="dt.pilih"
                                    ></w-checkbox>
                                </td>
                            </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td colspan="8" align="center">Tiada Rekod</td>
                      </tr>
                    </tbody>
                </table>
              </div>

            </w-flex>
             <w-flex class="mt3" wrap align-center justify-end>
                <div class="spacer" />
                <template v-if="$zutil.can('Penyata Pemungut Penyediaan')">
                  <template v-if="form.submitted == true">
                    <w-button class="my1"  :loading="form.submitted ">
                        <w-icon dark tile class="mr2">fal fa-save</w-icon> Jana Penyata Pemungut
                    </w-button>
                  </template>
                  <template v-else>
                    <w-button class="my1" type="submit" :disabled="form.valid === false" :loading="form.submitted ">
                        <w-icon dark tile class="mr2">fal fa-save</w-icon> Jana Penyata Pemungut
                    </w-button>
                  </template>
                    
                </template>

            </w-flex>

          </w-form>
                      <w-dialog
                v-model="dialogCek.show"
                :fullscreen="dialogCek.fullscreen"
                :width="dialogCek.width"
                :persistent="dialogCek.persistent"
                :persistent-no-animation="dialogCek.persistentNoAnimation"
                title-class="primary-light1--bg white"
            >
                <template #title>
                    <w-icon class="mr2">fal fa-user</w-icon>
                    Carian Pemungut Pemulangan Cek
                </template>
                <div class="page-wrapper-portal">
                    <w-flex justify-center align-center>
                        <div class="xs8">
                            <w-input
                                label="No. Penyata Pemungut"
                                v-model="carian_pp.q">
                            </w-input>
                        </div>
                        <div class="xs4">
                            <w-button 
                                class="ml1" 
                                @click="cariPP">Cari
                            </w-button>
                        </div>
                    </w-flex>
                    <div class="table-profil-scrol">
                        <table class="w-table">
                            <thead>
                                <tr>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        No. Penyata Pemungut
                                    </th>
                                     <th class="w-table__header w-table__header--sortable text-left">
                                        Tarikh Penyata Pemungut
                                    </th>
                                     <th class="w-table__header w-table__header--sortable text-left">
                                        Amaun (RM)
                                    </th>
                                     <th class="w-table__header w-table__header--sortable text-left">
                                        Cara Bayaran
                                    </th>
                                    <th class="w-table__header w-table__header--sortable text-left">
                                        Pilih
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(dt, index) in cekpp">
                                    <td class="w-table__cell text-left">
                                        {{ index + 1 }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.label }}
                                    </td>
                                    <td class="w-table__cell">
                                        {{$zutil.dateformat(dt.tarikh_sedia)}}
                                    </td>
                                    <td class="w-table__cell">
                                        {{$zutil.currency(dt.amaun)}}
                                    </td>
                                    <td class="w-table__cell">
                                        {{ dt.keterangan }}
                                    </td>
                                    <td class="w-table__cell text-right">
                                        <w-button
                                            class="my1"
                                            v-model="form.penyata_pemungut_id"
                                            @click="pilihPp(dt)"
                                            >Pilih
                                        </w-button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <template #actions>
                    <div class="spacer" />
                    <w-button
                        bg-color="grey-light5--bg"
                        @click="dialogCek.show = false"
                        >Tutup
                    </w-button>
                </template>
            </w-dialog>
      </z-page>
    </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZenOne from '@/Shared/ZenOne'
import ZResource from '@/Modules/z-resource-service'
// import moment from 'moment'


export default {
  extends: ZResource,
  components: {
    // ZenOne
  },
  props: {
    id: [Array, Object, String],
    items: [Array, Object, String],
    tarikh_bayar: [Array, Object],
  },
  data() {
    return {

        resourceurl: this.service_kutipan+'penyata_pemungut',
        reload: true,
        form:{
            resit: [],
            cek : null,
            bank : null,
        },

        carian_pp: { q: "" },
        form_cari: {},
        dialogCek: {
                valid: false,
                show: false,
                fullscreen: false,
                persistent: true,
                persistentNoAnimation: false,
                loading: false,
                width: 800,
                form: { nama: "", email: "" },
            },

        cekpp: [],
        bank_akaun: [],
        banks: [],
        pilih: false,
        
        crumbs: [
            // { label: this.$page.props.app_name, route: '/sitemap' },
            { label: 'iHasil', route: '/ihasil' },
            { label: 'Penyata Pemungut', route: 'kutipan/penyata_pemungut/index' },
            { label: 'Daftar Kaunter', route: 'kutipan/penyata_pemungut/daftar' }
          ],
          }
  },
  methods: {

    Cek() {
            this.dialogCek.show = 1;
        },
    cariPP() {
            if (this.carian_pp.q.length > 1) {
                this.$zcomm.post(this.service_utiliti + "lookup/penyata_pemungut_cek", this.carian_pp,{})
                    .then((res) => {
                        console.log(res);
                        this.cekpp = res;
                    });
            }
        },
    pilihPp(dt) {
            this.form_cari.id = dt.value;
            this.pemungutDetail();
    },

    pemungutDetail() {
            this.$zcomm
                .get(this.service_kutipan + "penyata_pemungut/" + this.form_cari.id)
                .then((res) => {
                    this.form.penyata_pemungut_id = res.id;
                    this.form.no_penyata_pemungut = res.no_penyata_pemungut;
                    this.dialogCek.show = false;
                });
        },

    
   
   
    getBankakaunbaru() { 
        
        this.$zcomm.get(this.service_utiliti+'lookup/bank_default').then(res => {
                  this.form.bank = res.value;
        this.getBanks();
        this.getBankakaun(this.form.bank);

                }); 
        

        },

    getBanks() { 
        
        this.$zcomm.get(this.service_utiliti+'lookup/tambah_bank').then(res => {
                  this.banks = res;  
                  // this.form.bank = res.value;

        // alert(this.form.bank);
                }); 
        

        },

    getBankakaun() { 
        
        // alert(this.form.bank);
        this.$zcomm.get(this.service_utiliti+'lookup/bank_akaun/'+this.form.bank).then(res => {
                  this.bank_akaun = res;

                this.getBankakaunketerangan();
                });
       
        },

    getBankakaunketerangan() { 
        
        // alert(this.form.bank);
        this.$zcomm.get(this.service_utiliti+'lookup/bank_akaun_keterangan/'+this.form.bank).then(res => {
                  this.form.bank_akaun_keterangan = res.keterangan;
                  // alert(this.form.bank_akaun_keterangan);
                });
       
        },

    


   



    cekPilih() {
            for (var i in this.form.resit) {
                this.form.resit[i].pilih = this.pilih;
            }
            
        },

     Resit() {
               this.$zcomm
                .get(
                        this.service_kutipan + "resitpemungut?tarikh_bayar="+this.form.tarikh_bayar
                )
                .then((res) => {
                    console.log(res);
                        // this.form.resit_id = res.resit.id;
                        // if(res.length > 0){
                          this.form.resit = res;
                        // }else{
                        //   this.$inertia.visit(
                        //     this.$route("kutipan.kaunter.akhir")
                        //     );
                        // }
                        // this.form.cara_bayaran = res.data.cara_bayaran;
                        
                });

        },

   
    submitPemugut(){
     if(this.form.valid == true){
      this.form.submitted = true
      this.form.lkp_sumber_id = 1
        this.$zcomm.post(this.resourceurl, this.form)
          .then(res => {
                          if (typeof this.onAfterAdd === "function") {
                              this.onAfterAdd()
                          }
                          this.$zutil.notify ("Rekod telah berjaya dihantar")
                          this.$inertia.visit(this.$route('kutipan.pemungut.index'))

                        })
                        .catch(err => {

                        })
                        .finally(() => {

                        });
     }
              
    },


    
    
    
  
    
  },
  watch: {
   
    
  },
  mounted() {
    if(!this.form.tarikh_bayar){
      this.form.tarikh_bayar = this.tarikh_bayar
      this.Resit()
    }

    this.getBankakaunbaru();
        // this.getBanks();
    
  },
}
</script>
<style>
.w-select__menu {
    z-index: 999999;
}
</style>
